import {
    GET_NEW_DISTRIBUTOR_LIST,
    GET_NEW_DISTRIBUTOR_LIST_REQUEST,
    GET_NEW_DISTRIBUTOR_LIST_FAILURE,
} from "./admin.actionsTypes";

const initialState = [];
// preserve loading flag on array for backwards compat
initialState.loading = false;

const withLoading = (arr, loading) => {
    const next = Array.isArray(arr) ? [...arr] : [];
    // preserve totalCount if exists
    if (arr && typeof arr.totalCount !== "undefined") next.totalCount = arr.totalCount;
    // preserve existing totalCount enumerable
    Object.defineProperty(next, 'loading', { value: loading, enumerable: true, writable: true, configurable: true });
    if (typeof next.totalCount !== "undefined") {
        Object.defineProperty(next, 'totalCount', { value: next.totalCount, enumerable: true, writable: true, configurable: true });
    }
    return next;
};

const buildSuccessArray = (payload) => {
    let arr = [];
    let totalCount;
    if (Array.isArray(payload?.distributors)) {
        arr = [...payload.distributors];
        totalCount = payload.totalCount;
    } else if (Array.isArray(payload?.data)) {
        arr = [...payload.data];
        totalCount = payload.totalCount;
    } else if (Array.isArray(payload)) {
        arr = [...payload];
        totalCount = payload.totalCount;
    } else {
        arr = [];
    }
    if (typeof totalCount === "number") {
        Object.defineProperty(arr, 'totalCount', { value: totalCount, enumerable: true, writable: true, configurable: true });
    } else if (payload && typeof payload.totalCount === "number") {
        Object.defineProperty(arr, 'totalCount', { value: payload.totalCount, enumerable: true, writable: true, configurable: true });
    }
    Object.defineProperty(arr, 'loading', { value: false, enumerable: true, writable: true, configurable: true });
    return arr;
};

export default function newDistributors(state = initialState, action) {
    switch (action.type) {
        case GET_NEW_DISTRIBUTOR_LIST_REQUEST:
            return withLoading(state, true);
        case GET_NEW_DISTRIBUTOR_LIST_FAILURE:
            return withLoading(state, false);
        case GET_NEW_DISTRIBUTOR_LIST:
            return buildSuccessArray(action.allDistributors || []);
        default:
            return state;
    }
}
